import { render, staticRenderFns } from "./signature-pad.component.vue?vue&type=template&id=16f3b13a&scoped=true&lang=pug"
import script from "./signature-pad.component.vue?vue&type=script&lang=ts"
export * from "./signature-pad.component.vue?vue&type=script&lang=ts"
import style0 from "./signature-pad.component.vue?vue&type=style&index=0&id=16f3b13a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f3b13a",
  null
  
)

export default component.exports